<template>
  <div class="data_content" :style="{height:height,width:width}">
    <div class="data_tabs">
      <div class="data_tabs_btn">
        <i class="el-icon-video-play" @click="handlePlay()" title="播放" v-if="showStart"></i>
        <i class="el-icon-video-pause" @click="handlePause()" title="暂停" v-else></i>
      </div>
      <div style="margin: 0 20px">
        <a-range-picker show-time
                        format="YYYY-MM-DD HH:mm:ss"
                        :default-value="times"
                        :placeholder="['开始时间', '结束时间']"
                        @ok="onDate"/>
      </div>
    </div>

    <div class="data_container" v-if="latestData">
      <template v-for="(item,index) in dataOption">
        <div class="data_container_item">
          {{ item.title }}:
          <div style="color:#0ff;margin-left: 10px;max-width:100px;word-break: break-all">
            {{ formatValue(item.dict, latestData[item.dict]) }}
          </div>
        </div>
      </template>

    </div>

    <div ref="mapContainer" class="map-container"></div>
  </div>
</template>
<script>
import moment from "moment";

import {
  queryWaterPoiBySite,
  queryWaterDataBySite
} from '@/api/api'

export default {
  props: {
    pipePositionLists: {
      default: () => {
        return []
      },
      type: Array
    },
    // 地图高度
    height: {
      default: '100%',
      type: String
    },
    width: {
      default: '100%',
      type: String
    },
    siteId: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      times:[],
      showStart: true,
      latestData: null,
      dataOption: [{
        title: '经度',
        dict: 'lng'
      }, {
        title: '纬度',
        dict: 'lat'
      }, {
        title: '电压(V)',
        dict: 'volt'
      }, {
        title: '温度(℃)',
        dict: 'temp'
      }, {
        title: '湿度(%)',
        dict: 'hum'
      }, {
        title: '海拔(m)',
        dict: 'altitude'
      }],
      state: false,
      passedPolyline: null,
      _moveEndHandler: null,
      _movingHandler: null,
      _animIdx: 0,
      speed: 15, // 轨迹回放速度，单位 米/秒 (m/s)。数值越小动画时间越长（播放越慢）
      playState: 'stop' // 播放状态：'stop' (已停止/未开始), 'playing' (播放中), 'paused' (暂停中)
    }
  },
  watch: {
    siteId: {
      handler(val) {
        console.log('siteId', val)
      },
      deep: true
    }
  },
  created() {
    // 实例属性挂载，避开 Vue 的 data 深度响应性性能损耗
    this.map = null
    this.marker = null
    this.lineArr = []
    this.times = [moment(moment().startOf('day').subtract(1, 'week').format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'), moment(moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss')]
  },
  mounted() {
    this.getNewData()
    this.initMap()
  },
  beforeDestroy() {
    this.stopAnimation()
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  },
  methods: {
    formatValue(key, val) {
      if (val === null || val === undefined || val === '') return '--'
      if (key === 'lng' || key === 'lat') {
        const str = String(val)
        const idx = str.indexOf('.')
        if (idx !== -1 && (str.length - idx - 1) > 8) {
          return str.substring(0, idx + 9)
        }
      }
      return val
    },
    initMap() {
      if (typeof AMap === 'undefined') {
        console.error('AMap SDK 未加载')
        return
      }

      // 使用 Vue ref 绑定独立的 DOM 元素，彻底避免同页面 ID 重合与热更新残留
      this.map = new AMap.Map(this.$refs.mapContainer, {
        // mapStyle: 'amap://styles/darkblue', // 极夜蓝
        zoom: 17,
        zooms: [3, 20],
        expandZoomRange: true,
        center: [116.397428, 39.90923],
        resizeEnable: true,
      })

      // 地图完全加载后再绑定数据
      this.map.on('complete', () => {
        this.getPathData()
      })
    },

    onDate(e) {
      this.times = e
      // 清理旧状态
      this.stopAnimation()
      if (this.map) {
        this.map.clearMap()
      }
      this.getPathData()
    },

    // 获取最新一条数据
    getNewData() {
      queryWaterDataBySite(this.siteId).then(res => {
        if (res.success) {
          this.latestData = res.result.firstData
        }
      })
    },

    getPathData() {
        let param = {
          siteId:this.siteId,
          stime: this.times[0].format('YYYY-MM-DD HH:mm:ss'),
          etime:this.times[1].format('YYYY-MM-DD HH:mm:ss')
        }

        queryWaterPoiBySite(param).then(res => {
          if (res.success) {
            if (res.result.length > 0) {
              let arr = []
              res.result.forEach(item => {
                if (item.indexOf('null') < 0) {
                  let datas = item.split(',')
                  let pathArr = []
                  datas.forEach(item2 => {
                    pathArr.push(item2 - 0)
                  })
                  arr.push(pathArr)
                }
              })
              this.lineArr = arr
              console.log('getPathData', arr.length)
            }
            this._bindMapPath()
          }
        })
    },

    _bindMapPath() {
      if (!this.lineArr || this.lineArr.length < 2) return

      // 绘制完整轨迹线（青色）
      new AMap.Polyline({
        map: this.map,
        path: this.lineArr,
        strokeColor: "#0ff",
        strokeWeight: 4,
      })

      // 已走过的轨迹线（红色）
      this.passedPolyline = new AMap.Polyline({
        map: this.map,
        strokeColor: "#c50d0d",
        strokeWeight: 6,
      })

      // 终点红色标记（静止不动）
      new AMap.Marker({
        map: this.map,
        position: this.lineArr[this.lineArr.length - 1],
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png'
      })

      // 移动标记（使用 content 方式，支持内层独立旋转避免高德动画重置样式）
      const carId = 'car-arrow-' + this._uid
      this.marker = new AMap.Marker({
        map: this.map,
        // content: `<div id="${carId}" style="width:26px;height:52px;background:url(/img/banner/upArrow.png) no-repeat;background-size:100% 100%;transition: transform 0.1s linear;filter: drop-shadow(0px 0px 4px rgba(255, 255, 255, 0.95));"></div>`,
        position: this.lineArr[0],
        // offset: new AMap.Pixel(-13, -26)
      })

      this.map.setCenter(this.lineArr[0])
      this.map.setZoom(17)
    },

    getAngle(p1, p2) {
      if (!p1 || !p2) return 0
      // 优先使用高德内置的高精度球面方向角计算，必须传入 LngLat 实例
      if (typeof AMap !== 'undefined' && AMap.GeometryUtil && AMap.GeometryUtil.getAngle) {
        const p1LngLat = new AMap.LngLat(p1[0], p1[1])
        const p2LngLat = new AMap.LngLat(p2[0], p2[1])
        return AMap.GeometryUtil.getAngle(p1LngLat, p2LngLat)
      }
      var x = p2[0] - p1[0]
      var y = p2[1] - p1[1]
      if (!x && !y) return 0
      return Math.atan2(x, y) * 180 / Math.PI
    },

    updateMarkerAngle(angle) {
      if (!this.marker) return
      this.marker.setAngle(angle) // 兼容官方属性

      // 实时更新内层 DOM 的 CSS3 旋转以防止 AMap 的 transform 覆盖
      const carId = 'car-arrow-' + this._uid
      const carEl = document.getElementById(carId)
      if (carEl) {
        carEl.style.transform = 'rotate(' + angle + 'deg)'
      }
    },

    getPathDistance() {
      if (!this.lineArr || this.lineArr.length < 2) return 0
      let totalDistance = 0
      if (typeof AMap !== 'undefined' && AMap.GeometryUtil && AMap.GeometryUtil.distance) {
        for (let i = 0; i < this.lineArr.length - 1; i++) {
          totalDistance += AMap.GeometryUtil.distance(this.lineArr[i], this.lineArr[i + 1])
        }
      } else {
        const first = this.lineArr[0]
        for (let i = 1; i < this.lineArr.length; i++) {
          if (this.lineArr[i][0] !== first[0] || this.lineArr[i][1] !== first[1]) {
            totalDistance = 100
            break
          }
        }
      }
      return totalDistance
    },

    handlePlay() {
      if (!this.marker || this.lineArr.length < 2) return
      if (this.playState === 'paused') {
        this.marker.resumeMove()
        this.playState = 'playing'
        this.showStart = false
      } else {
        this.start()
      }
    },

    handlePause() {
      if (this.marker && this.playState === 'playing') {
        this.marker.pauseMove()
        this.playState = 'paused'
        this.showStart = true
        if (this._moveEndTimer) {
          clearTimeout(this._moveEndTimer)
          this._moveEndTimer = null
        }
      }
    },

    // moveAlong 沿整条路径动画
    start() {
      if (!this.marker || this.lineArr.length < 2) return

      const totalDistance = this.getPathDistance()
      if (totalDistance < 1) {
        this.$message.warning('当前时段内设备无明显位移（距离小于1米），无法播放回放')
        return
      }

      // 停止已有动画并清理
      this.marker.stopMove()
      if (this._moveEndHandler) this.marker.off('moveend', this._moveEndHandler)
      if (this._movingHandler) this.marker.off('moving', this._movingHandler)
      if (this._moveEndTimer) { clearTimeout(this._moveEndTimer); this._moveEndTimer = null }

      this.showStart = false
      this.playState = 'playing'
      this.marker.setPosition(this.lineArr[0])

      if (this.passedPolyline) {
        this.passedPolyline.setPath([this.lineArr[0]])
      }

      var that = this

      // AMap 1.4.x 的 moveend 事件会在每段路径结束时触发（而非整条路径结束）
      // 使用防抖确保仅在最后一次 moveend 后才重置按钮状态
      this._moveEndHandler = function () {
        if (that._moveEndTimer) clearTimeout(that._moveEndTimer)
        that._moveEndTimer = setTimeout(function () {
          that.showStart = true
          that.playState = 'stop'
        }, 300)
      }
      this.marker.on('moveend', this._moveEndHandler)

      // 实时更新已走轨迹
      this._movingHandler = function (e) {
        if (that.passedPolyline && e.passedPath) {
          that.passedPolyline.setPath(e.passedPath)
        }
      }
      this.marker.on('moving', this._movingHandler)

      // 动态计算速度：确保回放至少持续 minDuration 秒，避免路径太短时瞬间播完
      var minDuration = 8
      var speedKmH = this.speed * 3.6
      var estimatedDuration = totalDistance / (speedKmH * 1000 / 3600)
      var actualSpeed = speedKmH
      if (estimatedDuration < minDuration) {
        var requiredSpeedMs = totalDistance / minDuration
        actualSpeed = requiredSpeedMs * 3.6
        if (actualSpeed < 0.01) actualSpeed = 0.01
      }

      this.marker.moveAlong(this.lineArr, actualSpeed)
    },

    stopAnimation() {
      this.showStart = true
      this.playState = 'stop'
      if (this._moveEndTimer) {
        clearTimeout(this._moveEndTimer)
        this._moveEndTimer = null
      }
      if (this.marker) {
        this.marker.stopMove()
        if (this._moveEndHandler) {
          this.marker.off('moveend', this._moveEndHandler)
          this._moveEndHandler = null
        }
        if (this._movingHandler) {
          this.marker.off('moving', this._movingHandler)
          this._movingHandler = null
        }
      }
    },
  }
}
</script>
<style lang="scss">
.data_content {
  width: 100%;
  height: 88vh;
  overflow-y: hidden;
  // padding: 10px 0;
  position: relative;
}

.map-container {
  width: 100%;
  height: 100%;
}

.data_tabs {
  position: absolute;
  z-index: 10;
  left: 10px;
  display: flex;
  align-items: center;

  .data_tabs_btn {
    cursor: pointer;
    font-size: 40px;
    color: #0ff;
  }
}

.data_container {
  position: absolute;
  z-index: 10;
  background: #4b677e;
  color: #fff;
  //height: 50px;
  border-radius: 10px;
  left: 10px;
  top: 60px;
  padding: 5px;

  .data_container_item {
    display: flex;
    align-items: center;
  }
}
</style>
